import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../slices/toast/reducer";

const DEFAULT_OPTIONS = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

const useToast = () => {
  const dispatch = useDispatch();

  return useCallback(
    (type, message, options = {}) => {
      if (!message) {
        return;
      }

      dispatch(
        showToast({
          type: type || "success",
          msg: message,
          options: { ...DEFAULT_OPTIONS, ...options },
        })
      );
    },
    [dispatch]
  );
};

export default useToast;

